import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const LogoHeader = () => {
  return (
    <div className="logo-header">
      <Link to="/">
        <img src="/images/logo-vertical.png" alt="Juani Pavlovsky Fotografías" className="logo-vertical-img" />
      </Link>
    </div>
  );
};

export default LogoHeader;